export const ORG_BASE_OVERRIDES = {
  "devon-qc": {
    baseOrg: "devon"
  }
};
